import appType from './ApiConfig';
import {
  DOMAIN_PIVOTEL, PRIMARY_COLOR_BUTTONS, PRIMARY_COLOR_BUTTONS_HOVER, PRIMARY_COLOR_BUTTONS_PIVOTEL, PRIMARY_COLOR_BUTTONS_PIVOTEL_HOVER,
} from './Constants';

export const BUTTON_COLOR = (appType === DOMAIN_PIVOTEL ? PRIMARY_COLOR_BUTTONS_PIVOTEL : PRIMARY_COLOR_BUTTONS);
export const BUTTON_HOVER_COLOR = (appType === DOMAIN_PIVOTEL ? PRIMARY_COLOR_BUTTONS_PIVOTEL_HOVER : PRIMARY_COLOR_BUTTONS_HOVER);

export const BUTTON_BACKGROUND_COLOR_STYLE = { backgroundColor: BUTTON_COLOR };
